var map = {
	"./appictus-nav.png": 5647,
	"./asma-nav.png": 5648,
	"./bienvenida-nav.png": 5649,
	"./breath-nav.png": 5650,
	"./cronicare-nav.png": 5651,
	"./default-nav.png": 5652,
	"./epid-nav.png": 5653,
	"./geoasma-nav.png": 5654,
	"./migraine-nav.png": 5655,
	"./misiones-nav.png": 5656,
	"./preanestesas-nav.png": 5657,
	"./preanestesas2-nav.png": 5658,
	"./prismax-nav.png": 5659,
	"./psapp-nav.png": 5660,
	"./recardio-nav.png": 5661,
	"./recardioob-nav.png": 5662,
	"./reuma-nav.png": 5663,
	"./reuma2-nav.png": 5664,
	"./rinobase-nav.png": 5665,
	"./salpro-nav.png": 5666,
	"./smartmigraine-nav.png": 5667,
	"./symphoni-nav.png": 5668,
	"./tep-nav.png": 5669,
	"./welcome-nav.png": 5670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;